import HomeView from '@/views/Home';

/**
 * Index Page - Simple wrapper for HomeView
 * All business logic and UI are in @/views/Home
 */
export default function IndexPage() {
  return <HomeView />;
}
